import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/api";

let cachePromise = null;

export default function useReviews() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let live = true;
    if (!cachePromise) {
      cachePromise = axios
        .get(`${API}/reviews`)
        .then((r) => r.data)
        .catch(() => ({ configured: false, reviews: [] }));
    }
    cachePromise.then((d) => {
      if (live) setData(d);
    });
    return () => {
      live = false;
    };
  }, []);

  return data;
}
